import defaultOptions from '@atlassian/jira-common-constants/src/fetch-default-options.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (url: string, options: any = {}): Promise<any> => {
	const option = { ...defaultOptions, ...options };
	return fetch(url, option).then((response) => {
		if (!response.ok) {
			const { status } = response;
			return response.text().then((str) => {
				throw new FetchError(status, str);
			});
		}

		return response.json();
	});
};
